import { IconClubCard } from './IconClubCard'

export default IconClubCard
